import { Chakra } from "@airhelp/react-ui-components";
import { TableSortUpIcon, TableSortDownIcon } from "styles/icons";
import { useTranslations } from "contexts/LocalizationContext";
import type { TableProps } from "../Table.d";

const { Thead, Tr, Th, Text, Flex } = Chakra;

const THead = ({ headerGroups }: Pick<TableProps, "headerGroups">) => {
  const translations = useTranslations();

  return (
    <Thead>
      {headerGroups.map((item, itemIdx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Tr {...item.getHeaderGroupProps()} key={headerGroups.length + itemIdx}>
          {item.headers.map((column, columnIdx) => (
            <Th
              // eslint-disable-next-line react/no-array-index-key
              key={column.id + columnIdx}
              {...column.getHeaderProps(column.getSortByToggleProps())}
              px={4}
              _first={{ border: "none" }}
            >
              <Text
                as="span"
                fontSize="sm"
                textTransform="none"
                color="primary.900"
                fontWeight="400"
                d="flex"
                align="center"
                letterSpacing="normal"
              >
                {column.render("Header") ? translations(column.render("Header")) : ""}
                {!column.disableSortBy && (
                  <Flex flexDir="column" mt="2px" ml={1}>
                    <TableSortUpIcon
                      opacity={column.isSorted ? (column.isSortedDesc ? 0.5 : 1) : 0.5}
                      mb={-1}
                      w="7.5px"
                      h="10px"
                    />
                    <TableSortDownIcon
                      opacity={column.isSorted ? (column.isSortedDesc ? 1 : 0.5) : 0.5}
                      w="7.5px"
                      h="10px"
                    />
                  </Flex>
                )}
              </Text>
            </Th>
          ))}
        </Tr>
      ))}
    </Thead>
  );
};

export default THead;
